// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__mu1n4","breadcrumbItem":"Breadcrumb_breadcrumbItem__awjHI","separator":"Breadcrumb_separator__oel6t"};